import styled from "styled-components";
import EnergySVG from "../../assets/icons/energy.svg";

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 419px;
  padding: 17px;
  border-radius: 8px;
  background-color: ${({ selected }) =>
    selected ? "var(--hover-background)" : "transparent"};
  transition: all 0.3s ease, padding 0.8s linear;

  :hover {
    background-color: ${({ selected }) =>
      selected ? "var(--hover-background)" : "var(--card-background)"};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-family: var(--font-heavy);
  font-size: 18px;
  letter-spacing: -0.01em;
  text-align: left;
  color: var(--purple-light);
`;

export const Tag = styled.span`
  font-family: var(--font-heavy);
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 0.02em;
  text-align: left;
  text-transform: uppercase;
  color: var(--text);
  margin-right: 14px;
  margin-bottom: 0;
`;

export const Description = styled(Tag)`
  font-family: var(--font-heavy);
  font-size: 12px;
  text-align: right;
  margin-right: 0;
`;

export const Value = styled(Title)`
  font-size: 20px;
  letter-spacing: -0.01em;
  text-align: right;
`;

export const Calories = styled(Title)`
  font-size: 11px;
  letter-spacing: 0.02em;
  text-align: center;
  margin-left: 3px;
  padding-top: 4px;
`;

export const EnergyIcon = styled.img.attrs({
  src: EnergySVG,
})`
  margin-right: 6px;
`;

export const Input = styled.input`
  font-family: var(--font-heavy);
  font-size: 20px;
  letter-spacing: -0.01em;
  text-align: right;
  color: var(--purple-light);
`;
